<template>
  <img :src="src" alt="PM2" />
</template>

<script>
import logo from '@/assets/pm2-logo.png'
import logoDarkText from '@/assets/pm2-logo-dark.png'
import mark from '@/assets/pm2-mark.png'

export default {
  name: 'DynamicLogo',
  props: {
    // Compact variant showing only the cube mark
    noText: Boolean,
  },
  computed: {
    src() {
      if (this.noText) return mark
      return this.$vuetify.dark ? logo : logoDarkText
    },
  },
}
</script>

<style lang="postcss" scoped></style>
